import { useEffect } from 'react'

export function disabledRightClick(e: MouseEvent) {
  e.preventDefault()
}

export function disableInspect(e: KeyboardEvent) {
  if (
    e.key === 'F12' ||
    (e.ctrlKey && e.shiftKey && e.key === 'I') ||
    (e.ctrlKey && e.shiftKey && e.key === 'C') ||
    (e.ctrlKey && e.shiftKey && e.key === 'J') ||
    (e.ctrlKey && e.key === 'U')
  ) {
    e.preventDefault()
  }
}

export function DisabledCopyContent() {
  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener('contextmenu', disabledRightClick)
      window.addEventListener('keydown', disableInspect)
    }

    return () => {
      window.removeEventListener('contextmenu', disabledRightClick)
      window.removeEventListener('keydown', disableInspect)
    }
  }, [])
  return null
}
